import { Button, Card } from "antd";
import styled from "styled-components";

export const ArticleCard = styled(Card)`
  border-color: transparent;
  box-shadow: 0px 4px 10px rgb(0 0 0 / 3%);
  /* width: 33%; */
  border-radius: 15px;
  .ant-card-body {
    padding: 8px 18px;
  }
  .ant-card-cover img {
    border-radius: 15px 15px 0px 0px;
    width: 100%;
    height: 250px;
  }
  p {
    margin: 0;
    color: #121111;
    font-size: 14px;
    font-weight: 600;
  }
  div.description {
    display: flex;
    flex-direction: column;
    p {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
  div.views {
    gap: 8px;
    display: flex;
    align-content: flex-start;
    justify-content: flex-start;
    align-items: center;
    color: #a3a9bf;
    font-size: 12px;
    margin-top: 8px;
  }
`;

export const ArticleTitle = styled.label`
  font-size: 19px;
  font-weight: 700;
  display: flex;
`;
export const ArticleImage = styled.img`
  border-radius: 15px;
  width: 100%;
`;
export const ArticleViews = styled.div`
  gap: 8px;
  display: flex;
  align-content: flex-start;
  justify-content: flex-start;
  align-items: center;
  font-size: 14px;
  margin-top: 8px;
  margin-left: 1px;
`;
export const Description = styled.div`
  display: flex;
  align-content: flex-start;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  .section-paragraph {
    margin-bottom: 30px;
  }
`;

export const LeftBlock = styled.div`
  text-align: left;
  display: flex;
`;
export const RightBlock = styled.div`
  font-size: 18px;
  display: inline-flex;
  cursor: pointer;
  text-align: right;
  right: 50px;
  @media (max-width: 768px) {
    font-size: 18px;
  }
`;
export const BookmarkBlock = styled.div``

export const LikeBlock = styled.div`
  cursor: pointer;
  text-align: left;
`;
export const ViewBlock = styled.div`
  cursor: pointer;
`;
export const dump = styled.div`
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;
export const ShareBlock = styled.div`
  text-align: right;
  padding-right: 7px;
`;
